<!--
	作者：masonchen
	时间：2017-04-12
	描述：车辆品牌维护页面
-->
<template>
		<div id="auth-list" class="wrapper-content h100pp tabBox">
		<div class="ibox float-e-margins ibox-content animated fadeInRight h100pp">
			<div class="form-horizontal h100pp">
				<div class="form-group h100pp">
					<div class="col-sm-4 pl20px pr20px h100pp">
						<div id="divBrand" style="overflow: auto; height: calc(100% - 40px);">
							<table class="table table-condensed table-hover">
								<thead>
									<tr class="info" role="row">
										<th></th>
										<th>品牌名称</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in brandData" role="row" v-bind:class="[item.isActive ? 'success' : '']" @click="brandClick(item)">
										<td class="text-center">
											<i @click="removeBrand(index)" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>{{item.name}}</td>
									</tr>
									<tr v-show="brandMode==='CREATE'" role="row">
										<td class="text-center">
											<i @click="brandMode='NORMAL'" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>
											<input id="inputBrand" type="text" class="form-control" v-model="newBrand.name"/>
										</td>								
									</tr>
								</tbody>
							</table>
						</div>
						<button class="btn btn-primary" @click="createBrand">{{brandStr}}</button>
					</div>
					<div class="col-sm-4 pl20px pr20px h100pp">
						<div id="divSerial" style="overflow: auto; height: calc(100% - 40px);">
							<table class="table table-condensed table-hover">
								<thead>
									<tr class="info" role="row">
										<th></th>
										<th>车系名称</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in serialData" role="row" v-bind:class="[item.isActive ? 'success' : '']" @click="serialClick(item)">
										<td class="text-center">
											<i @click="removeSerial(index)" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>{{item.name}}</td>
									</tr>
									<tr v-if="serialMode==='CREATE'" role="row">
										<td class="text-center">
											<i @click="serialMode='NORMAL'" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>
											<input id="inputSerial" type="text" class="form-control" v-model="newSerial.name"/>
										</td>								
									</tr>
								</tbody>
							</table>
						</div>
						<button class="btn btn-primary" @click="createSerial">{{serialStr}}</button>
					</div>
					<div class="col-sm-4 pl20px pr20px h100pp">
						<div id="divModel" style="overflow: auto; height: calc(100% - 40px);">
							<table class="table table-condensed table-hover">
								<thead>
									<tr class="info" role="row">
										<th></th>
										<th>车型名称</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in modelData" role="row" v-bind:class="[item.isActive ? 'success' : '']">
										<td class="text-center">
											<i @click="removeModel(index)" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>{{item.name}}</td>
									</tr>
									<tr v-if="modelMode==='CREATE'" role="row">
										<td class="text-center">
											<i @click="modelMode='NORMAL'" class="glyphicon glyphicon-trash"></i>
										</td>
										<td>
											<input id="inputModel" type="text" class="form-control" v-model="newModel.name"/>
										</td>								
									</tr>
								</tbody>
							</table>
						</div>
						<button class="btn btn-primary" @click="createModel">{{modelStr}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				brandData: [
					{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					},{
						name: '东风雪铁龙',
						isActive: false
					}
				],
				serialData: [
					{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					}
				],
				modelData: [
					{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					},{
						name: '比亚迪-唐',
						isActive: false
					}
				],
				newBrand: {
					name: "",
					isActive: false
				},
				newSerial: {
					name: "",
					isActive: false
				},
				newModel: {
					name: "",
					isActive: false
				},
				brandMode: "NORMAL",				// "CREATE" :创建    "NORMAL"：非创建
				serialMode: "NORMAL",				// "CREATE" :创建    "NORMAL"：非创建
				modelMode: "NORMAL"				// "CREATE" :创建    "NORMAL"：非创建
			}
		},
		computed: {
			brandStr: function(){
				if(this.brandMode === "NORMAL"){
					return "新建";
				}
				return "保存";
			},
			serialStr: function(){
				if(this.serialMode === "NORMAL"){
					return "新建";
				}
				return "保存";
			},
			modelStr: function(){
				if(this.modelMode === "NORMAL"){
					return "新建";
				}
				return "保存";
			}
		},
		updated(){
			// 点击
			if(this.brandMode === "CREATE"){
				document.getElementById("inputBrand").focus();
			}
			if(this.serialMode === "CREATE"){
				document.getElementById("inputSerial").focus();
			}
			if(this.modelMode === "CREATE"){
				document.getElementById("inputModel").focus();
			}
		},
		methods: {
			// 点击某个品牌
			brandClick(item){
				this.brandData.forEach(brand => {
					brand.isActive = false;
				});
				item.isActive = true;
			},
			// 点击某个车系
			serialClick(item){
				this.serialData.forEach(brand => {
					brand.isActive = false;
				});
				item.isActive = true;
			},
			// 点击删除品牌
			removeBrand(index){
				this.brandData.splice(index, 1);
			},
			// 点击删除车系
			removeSerial(index){
				this.serialData.splice(index, 1);
			},
			// 点击删除车型
			removeModel(index){
				this.modelData.splice(index, 1);
			},
			createBrand(){
				if(this.brandMode === "NORMAL"){
					this.brandMode = "CREATE";
					this.newBrand.name = "";
					return;
				}
				if(this.newBrand.name){
					var newBrand = {
						name : this.newBrand.name,
						isActive: false
					};
					this.brandData.push(newBrand);
					this.brandMode = "NORMAL";
				}
			},
			createSerial(){
				if(this.serialMode === "NORMAL"){
					this.serialMode = "CREATE";
					this.newSerial.name = "";
					var div = document.getElementById('divSerial');
					div.scrollTop = div.scrollHeight;
					return;
				}
				if(this.newSerial.name){
					var newSerial = {
						name : this.newSerial.name,
						isActive: false
					};
					this.serialData.push(newSerial);
					this.serialMode = "NORMAL";
				}
			},
			createModel(){
				if(this.modelMode === "NORMAL"){
					this.modelMode = "CREATE";
					this.newModel.name = "";
					var div = document.getElementById('divModel');
					div.scrollTop = div.scrollHeight;
					return;
				}
				if(this.newModel.name){
					var newModel = {
						name : this.newModel.name,
						isActive: false
					};
					this.modelData.push(newModel);
					this.modelMode = "NORMAL";
				}
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// PageVehicleMaster.vue?de4b5e72